import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import DataTableBOM from "./DataTableBOM";
import DataTableOperations from "./DataTableOperations";
import DataTableAssemblyComponentsWorkOrder from "./DataTableAssemblyComponentsWorkOrder";
import DataTableAssemblyComponentsDechetsWorkOrder from "./DataTableAssemblyComponentsDechetsWorkOrder";
import uploadAndDownloadService from "../../../../../services/uploadAndDownloadFile";
import { useNavigate } from "react-router-dom";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import { useState } from "react";
const DataTableWorkOrdersByPO = ({ listWorkOrder }) => {
  const navigate = useNavigate();

  const [availableWorkOrders, setAvailableWorkOrders] = useState([]);
  const [productionOrder, setProductionOrder] = useState([]);
  function handleTableChange({ products }) {
    return products;
  }

  // const expandRow = {
  //   renderer: (row) => importProduct(row),
  //   showExpandColumn: true,
  //   expandByColumnOnly: true,
  //   expandHeaderColumnRenderer: ({ isAnyExpands }) => {
  //     if (isAnyExpands) {
  //       return <b>-</b>;
  //     }
  //     return <b>+</b>;
  //   },
  //   expandColumnRenderer: ({ expanded }) => {
  //     if (expanded) {
  //       return <b>-</b>;
  //     }
  //     return <b>+</b>;
  //   },
  // };
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  function operationFormatter(cell, row) {
    return (
      <>
        {row.codeOperation}-{row.nameOperation}
      </>
    );
  }
  function stationFormatter(cell, row) {
    return (
      <>
        {row.codeWorkStation}-{row.nameWorkStation}
      </>
    );
  }
  function bomFormatter(cell, row) {
    return (
      <>
        {row.codeBOM}-{row.product.productCode}-{row.product.name}
      </>
    );
  }
  function stateFormatter(cell, row) {
    if (row.work_order_state === "PENDING") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-warning">
          En attente
        </span>
      );
    } else if (row.work_order_state === "STARTED") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-primary">
          En cours
        </span>
      );
    } else if (row.work_order_state === "FINISHED") {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-success">
          Terminé
        </span>
      );
    }
  }
  function priorityFormatter(cell, row) {
    return <>{row.priority}</>;
  }
  function creationDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.date_creation)}</span>;
  }
  function scheduledDateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.scheduled_date)}</span>;
  }
  function buttonListStepsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => {
          localStorage.setItem("idWorkOrder", row.idWorkOrder);
          navigate(`/workOrdersSteps`);
        }}
      >
        <i class="fas fa-eye"></i>
      </button>
    );
  }
  function buttonListDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => {
          localStorage.setItem("idWorkOrder", row.idWorkOrder);
          const pdfWindow = window.open();
          pdfWindow.location.href = "/workOrdersDetails";
          // navigate(`/workOrdersDetails`);
        }}
      >
        <i class="fas fa-eye"></i>
      </button>
    );
  }
  const columns = [
    {
      dataField: "idWorkOrder",
      text: "Opération",
      align: "center",
      formatter: operationFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Station de travail",
      align: "center",
      formatter: stationFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "BOM",
      align: "center",
      formatter: bomFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Priorité",
      align: "center",
      headerAlign: "center",
      formatter: priorityFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Etat",
      align: "center",
      formatter: stateFormatter,

      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },

    {
      dataField: "idWorkOrder",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: creationDateFormatter,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "scheduledDate",
      text: "Date limite",
      align: "center",
      headerAlign: "center",
      formatter: scheduledDateFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Détails",
      align: "center",
      headerAlign: "center",
      formatter: buttonListDetailsFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "idWorkOrder",
      text: "Etapes",
      align: "center",
      headerAlign: "center",
      formatter: buttonListStepsFormatter,

      headerStyle: () => {
        return { width: "10%" };
      },
    },
  ];

  // const testAvancement = (row) => {
  //   if (row.work_order_state === "PENDING") {
  //     return <span className="badge bg-danger">en attente</span>;
  //   } else if (row.work_order_state === "STARTED") {
  //     return <span className="badge bg-primary">en cours</span>;
  //   } else if (row.work_order_state === "FINISHED") {
  //     return <span className="badge bg-success">terminé</span>;
  //   }
  // };
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((error) => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : "+error);
      });
  };

  // const importProduct = (row) => {
  //   // startLoading();
  //   console.log(row.idWorkOrder);
  //   ProductionOrderService.getAllWorkOrdersDetailsByIdByPO(
  //     getCurrentUserId(),
  //     localStorage.getItem("idPO"),
  //     row.idWorkOrder
  //   )
  //     .then((response) => {
  //       console.log("response", response);
  //       if (response.data.success) {
  //         setAvailableWorkOrders(response.data.success);
  //         setProductionOrder(response.data.productionOrder);
  //       } else {
  //         // setOpenErrorAlert(true);
  //         // setErrorAlertText("Erreur : pas de bons de travails");
  //       }
  //     })
  //     .catch((e) => {
  //       console.log("error", e);
  //     });

  //   console.log("importProduct", row);
  //   return (
     
  //   );
  
  // };
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les bons de travails</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="idWorkOrder"
          data={listWorkOrder}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  // expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};
export default DataTableWorkOrdersByPO;
